import {Component, input} from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';

import {MapLayerComponent} from '../map-layer/map-layer.component';
import {GenServiceType} from '../../../generated/serverModels/GenServiceType';
import {MapGroup} from '../../classes/map-group';
import {SidebarGroupComponent} from '../sidebar-group/sidebar-group.component';
import {RestorationMetricLayerComponent} from '../layers/restoration-metric-layer/restoration-metric-layer.component';
import {CountyCoverageLayerComponent} from '../layers/county-coverage-layer/county-coverage-layer.component';
import {OutageEventCountLayerComponent} from '../layers/outage-event-count-layer/outage-event-count-layer.component';
import {HhsEmpowerLayerComponent} from '../layers/hhs-empower-layer/hhs-empower-layer.component';
import {VaDataCenterLayerComponent} from '../layers/va-data-center-layer/va-data-center-layer.component';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import {IceLayerComponent} from '../layers/ice-layer/ice-layer.component';
import {NighttimeLightsLayerComponent} from '../layers/nighttime-lights-layer/nighttime-lights-layer.component';
import {CountySrcLayerComponent} from '../layers/county-src-layer/county-src-layer.component';
import {CountyRankingLayerComponent} from '../layers/county-ranking-layer/county-ranking-layer.component';
import {
  SubstationHeadroomLayerComponent,
} from '../layers/substation-headroom-layer/substation-headroom-layer.component';
import {DatacentersLayerComponent} from '../layers/datacenters-layer/datacenters-layer.component';
import {AffordabilityLayerComponent} from '../layers/affordability-layer/affordability-layer.component';

@Component({
  selector: 'tgrid-map-layer-group',
  imports: [MatExpansionModule, MapLayerComponent, SidebarGroupComponent, RestorationMetricLayerComponent, CountyCoverageLayerComponent, OutageEventCountLayerComponent, HhsEmpowerLayerComponent, VaDataCenterLayerComponent, VulcanIconComponent, IceLayerComponent, NighttimeLightsLayerComponent, CountySrcLayerComponent, CountyRankingLayerComponent, SubstationHeadroomLayerComponent, DatacentersLayerComponent, AffordabilityLayerComponent],
  templateUrl: './map-layer-group.component.html',
  standalone: true,
  styleUrl: './map-layer-group.component.scss',
})
export class MapLayerGroupComponent {
  public mapLayerGroup = input.required<MapGroup>();
  protected serviceType = GenServiceType;


}
